import { Directive, HostBinding } from '@angular/core';

@Directive({ selector: 'mri-master-detail,[mriMasterDetail]', standalone: true })
export class MasterDetailDirective {
  @HostBinding('class.mri-master-detail') masterDetailHostClass = true;
  // note: this concept of applying a theme via css custom properties is a customization ON TOP OF the design system
  @HostBinding('style.border-top') borderTop = 'var(--mri-theme-border-style, initial)';
}
